module.exports = "./img/fe39fc2a5037ecfc514bd433465a5ac2.jpg";